module.exports = __webpack_public_path__ + "img/dwrank.f4a149ea.gif";